import { maxLengthMessage, requiredMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 50;

export const statementCaseNumberValidator = trimmedString.max(
  MAX_LENGTH,
  maxLengthMessage(MAX_LENGTH)
);
export const statementCaseNumberValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage);
